import { FunctionComponent } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import { colorDark, colorGrayDark, colorGrayLight } from "../../styles/theme";

interface Props {
	active: boolean;
	onToggle: () => void;
	// True while a translation triggered by this toggle is in flight.
	loading?: boolean;
	// When true the button stays hidden until the card is hovered (unless active).
	revealOnHover?: boolean;
}

const TranslateToggle: FunctionComponent<Props> = ({
	active,
	onToggle,
	loading = false,
	revealOnHover = false,
}) => {
	return (
		<IconButton
			className={revealOnHover ? "cardCopyButton" : undefined}
			onClick={onToggle}
			aria-label="Translate to English"
			aria-pressed={active}
			sx={{
				width: "32px",
				height: "32px",
				color: active ? colorDark : colorGrayDark,
				backgroundColor: active ? colorGrayLight : "transparent",
				// Active buttons are always visible; inactive ones reveal on hover.
				opacity: active || !revealOnHover ? 1 : 0,
				transition: "opacity 0.15s ease, background-color 0.15s ease",
				"&:hover": {
					backgroundColor: active ? colorGrayLight : undefined,
				},
			}}
		>
			{loading ? (
				<Box
					sx={{
						width: 16,
						height: 16,
						borderRadius: "50%",
						border: "2px solid rgba(127, 127, 135, 0.3)",
						borderTopColor: active ? colorDark : colorGrayDark,
						boxSizing: "border-box",
						animation: "cardHeadSpin 0.7s linear infinite",
						"@keyframes cardHeadSpin": {
							"0%": { transform: "rotate(0deg)" },
							"100%": { transform: "rotate(360deg)" },
						},
					}}
				/>
			) : (
				<TranslateIcon sx={{ width: 20, height: 20 }} />
			)}
		</IconButton>
	);
};

export default TranslateToggle;
